import styled from "styled-components";

//Interface
import { StatusContainerInterface } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";
import color from "../../assets/css/colors";

export const TitleAndStatusContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`;

export const StatusContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 12px;
    padding: 4px 13px;
    background: ${(p: StatusContainerInterface) => p.color} 0% 0% no-repeat padding-box;
    border-radius: 9px;
    font: normal normal normal 7px Circular Std Book;
    color: ${colors.white};
`;

export const Title = styled.h1`
    font: normal normal normal 32px Circular Std Book;
    color: ${colors.primary};
    margin: 0px;
    line-height: 1;
`;

export const Date = styled.p`
    font: normal normal normal 12px Circular Std Book;
    color: ${colors.grayDark};
`;

export const Close = styled.button`
    width: 30px;
    height: 30px;
    padding: 0px;
    border: none;
    outline: none;
    background-color: ${colors.white};

    &:focus{
        outline: none;
    }
`;

export const AlertContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 31px;
    padding-left: 9px;
    padding-right: 9px;
    background: ${colors.redLight} 0% 0% no-repeat padding-box;
    border-radius: 8px;
    opacity: 1;
`;

export const ErrorTitle = styled.span`
    font: normal normal normal 11px Circular Std Book;
    color: ${colors.redDark};
    margin-left: 7px;
`;

export const ErrorDescription = styled.span`
    font: normal normal normal 9px Circular Std Book;
    color: ${colors.tertiary};
    margin-left: 12px;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    @media (max-width: 500px){
        display: block;
    }
`;

export const Jumbotron = styled.div`
    width: 219px;
    background: ${colors.grayLightest} 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding: 20px 9px;
    line-height: 0;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
    }
`;

export const CreditCardContainer = styled.div`
    display: flex;
    justify-content: center;
`

export const JumbotronTitle = styled.h2`
    font: normal normal normal 14px Circular Std Book;
    color: ${colors.primary};
`;

export const InfoTitle = styled.h3`
    font: normal normal normal 10px Circular Std Book;
    color: ${colors.grayDark};
    margin: 0px;
    margin-bottom: 5px;
`;

export const Info = styled.p`
    font: normal normal normal 10px Circular Std Book;
    color: ${colors.tertiary};
    margin-bottom: 6px;
`;